import { I18n } from '@/services/i18n';

type Message = {
  beginYourJourney: string;
  welcome: string;
  showLimitedOffers: string;
  meetNewNicePeopleOnline: string;
  next: string;
  free: string;
  rightNowYouAreOn: string;
  freeSubscription: string;
  trial: string;
  premium: string;
  seeBasicProfilesOfOtherSingles: string;
  titleFreeSubscription: string;
  limitedChatting: string;
  limitedLikes: string;
  feature1: string;
  feature1v2: string;
  feature2: string;
  feature3: string;
  feature4: string;
  feature5: string;
  feature6: string;
  feature7: string;
  continue: string;
  showOffers: string;
};

const messages: I18n<Message> = {
  en: {
    beginYourJourney: 'Begin your journey at MeetMyAge!',
    welcome: 'Welcome, {name}!',
    showLimitedOffers: 'SHOW LIMITED OFFERS',
    meetNewNicePeopleOnline:
      'Meet new nice people online, make friends and spend quality time together. This is what you need to know right now about our platform...',
    next: 'Next',
    free: 'Free',
    rightNowYouAreOn: 'Right now you are on',
    freeSubscription: 'free subscription',
    trial: 'Premium',
    premium: 'With Premium',
    seeBasicProfilesOfOtherSingles: 'See basic profiles of other singles',
    titleFreeSubscription: 'Free subscription',
    limitedChatting: 'Limited chatting',
    limitedLikes: 'Limited likes',
    feature1: 'See all photos and full profiles of other singles',
    feature1v2: 'See all profiles of other singles',
    feature2: 'Unlimited likes',
    feature3: 'Advanced filters',
    feature4: 'Unlimited chatting',
    feature5: 'See who likes you',
    feature6: 'Boost your profile',
    feature7: 'No Ads',
    continue: 'Continue',
    showOffers: 'SHOW OFFERS',
  },
  es: {
    beginYourJourney: '¡Empieza tu viaje en MeetMyAge!',
    welcome: '¡Bienvenido, {name}!',
    showLimitedOffers: 'MOSTRAR OFERTAS LIMITADAS',
    meetNewNicePeopleOnline:
      'Conoce nuevas personas agradables en línea, haz amigos y pasa tiempo de calidad juntos. Esto es lo que necesitas saber ahora sobre nuestra plataforma...',
    next: 'Siguiente',
    free: 'Gratis',
    rightNowYouAreOn: 'Ahora mismo estás en',
    freeSubscription: 'suscripción gratuita',
    trial: 'Prueba',
    premium: 'Con Premium',
    seeBasicProfilesOfOtherSingles: 'Ver perfiles básicos de otros solteros',
    titleFreeSubscription: 'Suscripción gratuita',
    limitedChatting: 'Chat limitado',
    limitedLikes: 'Me gusta limitados',
    feature1: 'Ver todas las fotos y perfiles completos de otros solteros',
    feature1v2: 'Ver todos los perfiles de otros solteros',
    feature2: 'Likes ilimitados',
    feature3: 'Filtros avanzados',
    feature4: 'Chat ilimitado',
    feature5: 'Veamos a quién le gustas',
    feature6: 'Impulsa tu perfil',
    feature7: 'Sin anuncios',
    continue: 'Continuar',
    showOffers: 'MOSTRAR OFERTAS',
  },
  de: {
    beginYourJourney: 'Beginnen Sie Ihre Reise bei MeetMyAge!',
    welcome: 'Willkommen, {name}!',
    showLimitedOffers: 'LIMITIERTE ANGEBOTE ANZEIGEN',
    meetNewNicePeopleOnline:
      'Treffen Sie neue nette Leute online, knüpfen Sie Freundschaften und verbringen Sie qualitativ hochwertige Zeit zusammen. Das müssen Sie jetzt über unsere Plattform wissen...',
    next: 'Weiter',
    free: 'Basis',
    rightNowYouAreOn: 'Zur Zeit sind Sie auf',
    freeSubscription: 'kostenloses Abonnement',
    trial: 'Premium',
    premium: 'Mit Premium',
    seeBasicProfilesOfOtherSingles: 'Sehen Sie grundlegende Profile anderer Singles',
    titleFreeSubscription: 'Basis',
    limitedChatting: 'Begrenztes Chatten',
    limitedLikes: 'Begrenzte Likes',
    feature1: 'Sehen Sie alle Fotos und vollständige Profile anderer Singles',
    feature1v2: 'Sehen Sie alle Profile anderer Singles',
    feature2: 'Unbegrenzte Likes',
    feature3: 'Erweiterte Filter',
    feature4: 'Unbegrenztes Chatten',
    feature5: 'Sehen Sie, wer Sie mag',
    feature6: 'Boosten Sie Ihr Profil',
    feature7: 'Keine Anzeigen',
    continue: 'Fortfahren',
    showOffers: 'ANGEBOTE ANZEIGEN',
  },
};

export { messages };
